import React from 'react'
import * as AntdComponents from 'antd'
import { STATIC_IMAGES } from '../utils/StaticImages'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        // Centralized hook: swap this for a monitoring service
        // (e.g. Sentry.captureException(error, { extra: errorInfo })) when one is wired up.
        console.error('Unhandled UI error:', error, errorInfo)
    }

    handleReload = () => {
        this.setState({ hasError: false })
        window.location.reload()
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center" style={{ height: '100vh' }}>
                    <AntdComponents.Image src={STATIC_IMAGES.LOGO} preview={false} height={60} />
                    <AntdComponents.Typography className='titleMedium text-center mt-5'>Something went wrong.</AntdComponents.Typography>
                    <AntdComponents.Typography className='description text-center mt-2'>Please refresh the page and try again.</AntdComponents.Typography>
                    <div className="mt-5">
                        <AntdComponents.Button className='common-button bg-Black text-White' onClick={this.handleReload}>Reload</AntdComponents.Button>
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
